import { ActionIcon, Group } from "@mantine/core";
import type { FC } from "react";
import { useIntl } from "react-intl";
import type { Style, StyleVersion } from "../types/map";
import { MapMenu } from "../../components/MapMenu.js";
import type { AccountInfo } from "@mapka/style-editor";
import { useDisclosure } from "@mantine/hooks";
import { ShareMapModal } from "./ShareMapModal";
import { IconShare } from "@tabler/icons-react";
import { stopPropagation } from "../../../../utils/stopPropagation.js";

export interface MapItemControlsProps {
  account: AccountInfo;
  style: Style;
  version: StyleVersion;
}

export const MapItemControls: FC<MapItemControlsProps> = ({ style, account, version }) => {
  const intl = useIntl();
  const [shareModalOpen, { open: openShareModal, close: closeShareModal }] = useDisclosure(false);

  const shareLabel = intl.formatMessage({
    defaultMessage: "Share map",
    id: "button.shareMap",
  });

  return (
    <Group gap="xs" onClick={stopPropagation}>
      <ActionIcon
        variant="default"
        onClick={openShareModal}
        aria-label={shareLabel}
        size={32}
      >
        <IconShare size={20} />
      </ActionIcon>

      <MapMenu
        {...{ style, account, version }}
        width={200}
        position="bottom-end"
      />

      {shareModalOpen && (
        <ShareMapModal
          opened={shareModalOpen}
          onClose={closeShareModal}
          style={style}
          version={version}
          accountName={account.name}
        />
      )}
    </Group>
  );
};
